/**
 * Vite entry point for the Anvil SPA.
 */

// --- Pre-built application stylesheet ---
import './scss/main.scss'

// --- Vendor CSS ---
// Bootstrap and bootstrap-select CSS are handled by scss/main.scss — do NOT
// import them again here.
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-icons/iconfont/material-icons.css'
import 'material-symbols/index.css'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'
import 'leaflet/dist/leaflet.css'
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

// --- Core dependencies ---
import './entry-globals'

// --- Bootstrap ecosystem ---
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-select'
import 'selectize'

import BootstrapMenu from 'bootstrap-menu'
window.BootstrapMenu = BootstrapMenu

// --- Leaflet plugins ---
import 'leaflet.awesome-markers'
import 'leaflet.markercluster'

// --- FullCalendar ---
import { Calendar, globalPlugins, globalLocales } from 'fullcalendar'
window.FullCalendar = { Calendar, globalPlugins, globalLocales }

import huLocale from '@fullcalendar/core/locales/hu'
globalLocales.push(huLocale.default || huLocale)

// --- Chart.js ---
import Chart from 'chart.js/auto'
import 'chartjs-adapter-date-fns'
window.Chart = Chart

// FontAwesome SVG+JS core library.
import '@fortawesome/fontawesome-free/js/fontawesome.min.js'

// --- Anvil engine ---
import Anvil from './core/anvil.js'

// Eagerly import all controllers, models, and views.
// Vite resolves these globs at build time and includes every matched module in
// the bundle, then passes an object keyed by path to the autoloader.
const controllerGlob = import.meta.glob('./controllers/**/*.js', { eager: true })
const modelGlob      = import.meta.glob('./models/**/*.js',      { eager: true })
const viewGlob       = import.meta.glob('./views/**/*.ejs',      { eager: true })

window.Anvil = Anvil

// Boot Anvil once the DOM is ready.
$(async () => {
	await Anvil.load(controllerGlob, modelGlob, viewGlob)
	await Anvil.init()
})
